// @flow

const RE_DATE_WITH_HOUR = /(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})[+-](\d{2}):(\d{2})/;

export function formatUberPixExpirationDatetime(stringDate: string): string {
  if(!stringDate) return '';

  const matchObj = RE_DATE_WITH_HOUR.exec(stringDate);

  if(!matchObj)
    throw new Error('Voucher: invalid payload expiration datetime format: ' + stringDate);

  const expirationDate = new Date(stringDate);

  const month = (expirationDate.getMonth() + 1).toString().padStart(2, '0');
  const day = expirationDate.getDate().toString().padStart(2, '0');
  const hour = expirationDate.getHours().toString().padStart(2, '0');
  const minutes = expirationDate.getMinutes().toString().padStart(2, '0');

  return `${day}/${month}, ${hour}:${minutes}`;
}
